// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyCtaFooter-cls1_1US","cls2":"StickyCtaFooter-cls2_3FL StickyCtaFooter-cls1_1US"};